import React, { useEffect, useState } from 'react';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import './styles.css';
import RenderSvgIcon from '../../RenderSvgIcon';
import { renderSearchBoxItemJob } from '../../../utils/utils';
import IconItemJob from '../IconItemJob';
import { PROFILE } from '../../../config/constants';
import { useQuery } from 'react-query';
import * as agentResourceApi from '../../../api/agentResources';
import IconItemAgent from '../IconItemAgent';
import PropTypes from 'prop-types';


const wrapStyleIcon1 = {
  width: 17,
  height: 17,
  fill: 'currentColor',
  alignSelf: 'center',
  transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
};

function Index({ jobList, history, act, itemJobResources, type, agentResource}) {
  // const { data: agentResource1 } = useQuery(['agentResource'], () => agentResourceApi.getAllResource());
  // const [showResourceAgents, setShowResourceAgents] = useState([]);


  // useEffect(() => {
  //   if (agentResource && agentResource?.data) {
  //     const tmp = agentResource?.data
  //       ?.filter((item) => item.value === PROFILE.ROOT)
  //       .sort((a, b) => a.profileOrder - b.profileOrder);
  //
  //     setShowResourceAgents(tmp);
  //   }
  // }, [agentResource]);

  if (!jobList) {
    return null;
  }

  const renderItemJobElement = (job) => {
    const { itemParent } = renderSearchBoxItemJob(itemJobResources ?? [], job?.attribute);

    return Object.keys(itemParent)
      .sort((a, b) => itemParent[a].searchOrder - itemParent[b].searchOrder)
      .map((item, key) => {
        return (
          <ListItem key={key}>
            <IconItemJob item={item} />
            <ListItemText
              primary={
                <span className='font-3' style={{ color: 'var(--text3)' }}>
                  {itemParent[item].selectedObj && itemParent[item].selectedObj?.label}
                </span>
              } />
          </ListItem>
        );
      });
  };

  const findAttributes = (resourceName, agentProfile) => {
    if (!agentProfile?.attributes) {
      return ''
    }

    let parentName = agentResource?.data?.find((x) => x.label === resourceName);
    let responseResources = agentResource?.data?.find(x => {
        return agentProfile?.attributes
          && agentProfile?.attributes[parentName?.profile]
          && x.profile === parentName?.profile
          && +x.value === +agentProfile?.attributes[parentName?.profile];
      },
    );

    return responseResources?.label;
  };

  const renderItemAgentElement = (agent) => {
    return (agentResource?.agentResourceShows || []).map((resourceItem, key) => {
      return (
        <ListItem key={key} className={"d-item-col-2"}>
          <IconItemAgent item={resourceItem?.profile} />
          <ListItemText
            primary={
              <div className="wrapperSalary d-flex">
                <span className="label-profile" style={{ color: 'var(--text2)', fontSize: 14 }}>{resourceItem.label}</span>
                <span className="font-3 text-right"
                      style={{ color: 'var(--text3)' }}>{findAttributes(resourceItem.label, agent)}</span>
              </div>
            } />
        </ListItem>
      );
    });
  };

  const renderImageJobMain = (imgJobMains = []) => {
    const imgJobMain = imgJobMains.filter(ele => ele?.type && +ele?.type === 1);

    let urlMain = require('assets/image-icon/no_job_photo.png');
    if (imgJobMain && imgJobMain.length) {
      urlMain = imgJobMain[0]?.url;
    }

    return (<img style={{ width: '160px', maxHeight: '125px', objectFit: 'cover' }} src={urlMain} alt="job-image" />);
  };

  const clickJobDetail = (id) => {
    history.push({
      pathname: `${process.env.RAZZLE_PUBLIC_URL}/job-detail/${id}`,
      search: `${act ? 'act=' + act : ''}`,
    });
  };

  const wrapStyleArrow = {
    paddingRight: 3,
    width: 24,
    height: 24,
    color: 'var(--text-secondary)',
    fill: 'currentColor',
    alignSelf: 'flex-start',
  };

  return (
    <React.Fragment>
      {jobList && jobList.map((item, index) => (
        <React.Fragment key={index}>
          <div key={index} style={{ padding: '0 20px' }} className="d-wrapper">
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 5 }}>
              <div className="d-line-1-title" style={{ width: '100%' }}>
                {item?.agent?.nickName && (<div className="agent-nick-name">
                  <span className="text2" title={item?.agent?.nickName}
                        style={{ color: 'var(--text2)' }}>{item?.agent?.nickName}</span>
                </div>)
                }
                <div className="d-job-title"
                     style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span className="font-4" title={item?.title}
                        style={{ color: 'var(--text4)', width: 'calc(100% - 25px)' }}>{item?.title}</span>
                  <RenderSvgIcon
                    onClick={() => clickJobDetail(item.id)}
                    name={'SVG_forward_right_icon'}
                    fill="var(--text-secondary)"
                    style={wrapStyleArrow}
                    className={'d-svg'}
                  />
                </div>
              </div>
            </div>

            <List
              sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
              aria-label="contacts"
              className="d-list-detail"
            >
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div className={"d-item-col-2"}>
                <ListItem>
                  <RenderSvgIcon name={'SVG_locate'} style={wrapStyleIcon1} />
                  <ListItemText
                      primary={
                        <div className="wrapperSalary d-flex">
                          <span className="label-profile" style={{ color: 'var(--text2)' , fontSize: 14 }}>給与幅</span>
                          <div className="text-right wrapperSalaryRight" style={{ marginLeft: 30 }}>
                            <span className="label-profile font-3">{item?.minimumSalary?.toLocaleString()}円</span>
                            <span className="label-profile font-3 salaryText">~</span>
                            <span className="label-profile font-3">{item?.maximumSalary?.toLocaleString()}円</span>
                          </div>
                        </div>
                      }
                    />
                   </ListItem>
                  <ListItem>
                    <RenderSvgIcon name={'SVG_locate'} style={wrapStyleIcon1} />
                    <ListItemText primary={
                      <div className="wrapperSalary d-flex">
                        {['search-job-trial-result', 'search-job-result'].includes(type) && <span className="label-profile" style={{ color: 'var(--text2)' , fontSize: 14 }}>都道府県</span>}
                        <span className='font-3 text-right' style={{ color: 'var(--text3)' }}>{item?.state?.label}</span>
                      </div>
                    } />
                  </ListItem>
                  <ListItem>
                    <RenderSvgIcon name={'SVG_pin'} style={wrapStyleIcon1} />
                    <ListItemText
                      primary={<div className="wrapperSalary d-flex">
                        {['search-job-trial-result', 'search-job-result'].includes(type) && <span className="label-profile" style={{ color: 'var(--text2)' , fontSize: 14 }}>エリア</span>}
                        <span className='font-3 text-right' style={{ color: 'var(--text3)' }}>{item?.area?.label}</span>
                      </div>
                    } />
                  </ListItem>
                  {/*Render item form DB*/}
                  {['search-job-list-result'].includes(type) && renderItemJobElement(item)}

                </div>
                {item?.imageJobs && (
                  <div style={{ width: '30%' }} className="d-line-1-img">{renderImageJobMain(item?.imageJobs)}</div>)
                }
              </div>
              {/*SEO ???*/}
              {['search-job-trial-result', 'search-job-result'].includes(type) && renderItemAgentElement(item?.agent)}

              <ListItem className="d-detail-work">
                <ListItemText
                  primary={<span className="detail-work font-3"
                                 style={{ color: 'var(--text3)' }}>{item?.workDetail}</span>} />
              </ListItem>

              {item?.tagNameJobs && item?.tagNameJobs.length ?
                (<ListItem>
                  <div>
                    {(item?.tagNameJobs ?? []).map((v, i) => (
                      <div key={i} className="tag">{v.label}</div>
                    ))}
                  </div>
                </ListItem>) : ''
              }
            </List>
          </div>
          <Divider />
        </React.Fragment>
      ))}
    </React.Fragment>
  );
}


Index.propTypes = {
  agentResource: PropTypes.shape({
      data: PropTypes.array,
    agentResourceShows: PropTypes.array
  })
};

export default Index;
